import {
	AMap,
	AMapGeocoder,
	AMapMarker,
	AMapMouseTool,
	AMapPolygon,
	AMapInfoWindow
} from 'amap'

export default function(Vue, options) {
	var components = {
		AMap,
		AMapGeocoder,
		AMapMarker,
		AMapMouseTool,
		AMapPolygon,
		AMapInfoWindow,
	}

	// 手动加载插件$_AMap（高德地图 ）
	Vue.prototype.$_AMap = {
		key: options.key, // 开发者key
		version: options.version, // 版本号
		plugins: options.plugins || [], // 预加载插件
	}

	// 注册组件
	for (var c in components) {
		Vue.component(c, components[c])
	}
}